import React from 'react';
import { motion } from 'framer-motion';
import { Star, ArrowRight, Clock, Users, BookOpen } from 'lucide-react';
import { TricolorStripe } from './TricolorStripe';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/8Aw9jLDp6JjxgjUoVSorDX/98930e38-5ebb-403e-a4c3-f1e5763261a4.png';
export function Hero() {
  return <section className="relative bg-slate-900 text-white overflow-hidden" data-id="element-139">
      <TricolorStripe data-id="element-140" />

      {/* Background decoration */}
      <div className="absolute inset-0 opacity-[0.07] bg-[url('https://images.unsplash.com/photo-1523730205978-59fd1b2965e3?q=80&w=2000&auto=format&fit=crop')] bg-cover bg-center" data-id="element-141" />
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-900 to-emerald-950/40" data-id="element-142" />
      <div className="absolute top-1/4 -left-32 w-96 h-96 bg-emerald-500/10 rounded-full blur-3xl" data-id="element-143" />
      <div className="absolute bottom-0 -right-32 w-96 h-96 bg-red-500/10 rounded-full blur-3xl" data-id="element-144" />

      <div className="container mx-auto px-4 relative z-10 max-w-4xl py-12 md:py-16 lg:py-20" data-id="element-145">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-146">
          {/* Rating badge */}
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-500/10 text-emerald-300 border border-emerald-500/30 mb-5 text-xs md:text-sm font-semibold" data-id="element-147">
            <span className="flex gap-0.5" data-id="element-148">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-current" data-id="element-149" />)}
            </span>
            <span data-id="element-150">4.9/5 • Elegido por profesores de italiano en LATAM</span>
          </div>

          {/* Title */}
          <h1 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight mb-6 md:mb-8 leading-[1.1] max-w-3xl mx-auto" data-id="element-151">
            Convertí tus clases de italiano en un{' '}
            <span className="text-emerald-400" data-id="element-152">sistema profesional</span>
          </h1>

          {/* Product Image — between title and subtitle */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.15
        }} className="relative mb-6 md:mb-8" data-id="element-153">
            <a href="#compra" className="block group relative max-w-md md:max-w-lg mx-auto" data-id="element-154">
              {/* Glow */}
              <div className="absolute inset-0 bg-emerald-500/20 blur-3xl scale-90 group-hover:scale-100 transition-transform" data-id="element-155" />
              <img src={PRODUCT_IMG} alt="Italiano Pro Kit — Sistema de clases listas para usar" className="relative w-full h-auto drop-shadow-2xl group-hover:scale-[1.02] transition-transform duration-500" data-id="element-156" />
              {/* Floating discount badge */}
              <div className="absolute -top-2 -right-2 md:top-4 md:right-4 bg-red-600 text-white text-xs md:text-sm font-bold px-3 py-2 rounded-full shadow-lg rotate-12 border-2 border-white" data-id="element-157">
                -60% HOY
              </div>
            </a>
          </motion.div>

          {/* Subtitle */}
          <p className="text-lg md:text-2xl font-medium text-slate-300 mb-3 md:mb-4 leading-snug max-w-2xl mx-auto" data-id="element-158">
            TODO TU SISTEMA DE CLASES RESUELTO{' '}
            <span className="text-amber-300" data-id="element-159">(SIN IMPROVISAR)</span>
          </p>
          <p className="text-sm md:text-base text-slate-400 mb-6 md:mb-8 max-w-xl mx-auto" data-id="element-160">
            Clases de italiano listas para usar, diseñadas para que dejes de
            improvisar y ahorres horas de preparación cada semana.
          </p>

          {/* Quick benefits row */}
          <div className="flex flex-wrap justify-center gap-3 md:gap-5 mb-7 text-xs md:text-sm text-slate-300" data-id="element-161">
            <span className="flex items-center gap-1.5" data-id="element-162">
              <BookOpen className="w-4 h-4 text-emerald-400" data-id="element-163" /> +50 clases
            </span>
            <span className="flex items-center gap-1.5" data-id="element-164">
              <Clock className="w-4 h-4 text-emerald-400" data-id="element-165" /> Listas para usar
            </span>
            <span className="flex items-center gap-1.5" data-id="element-166">
              <Users className="w-4 h-4 text-emerald-400" data-id="element-167" /> A1 – A2
            </span>
          </div>

          {/* CTA */}
          <a href="#compra" className="inline-flex items-center justify-center gap-2 bg-emerald-500 hover:bg-emerald-400 text-white text-base md:text-lg font-bold py-3.5 px-7 rounded-xl shadow-xl shadow-emerald-500/30 transition-all hover:scale-[1.03]" data-id="element-168">
            QUIERO MI SISTEMA AHORA
            <ArrowRight className="w-5 h-5" data-id="element-169" />
          </a>

          <p className="mt-4 text-xs text-slate-500 flex items-center justify-center gap-2" data-id="element-170">
            <span className="inline-block w-2 h-2 rounded-full bg-emerald-400 animate-pulse" data-id="element-171" />
            Acceso inmediato • Pago seguro
          </p>
        </motion.div>
      </div>
    </section>;
}